export default __webpack_public_path__ + "static/media/mobile_accordances.c37531f7.svg";